import React from 'react';
import classNames from 'classnames';
import { decode } from './../../util/html';
require('./ApprovalOpt.scss');
/*
 */
class ApprovalOpt extends React.Component {
    constructor(props) {
        super(props);
        this.handlePut = this.handlePut.bind(this);
        this.handleSpread = this.handleSpread.bind(this);
        this.state = {
            button: ''
        };
    }

    componentDidMount() {
        const text = this.refs.approvalText;
        if (text) {
            const textWidth = text.offsetWidth;
            const textScrollWidth = text.scrollWidth;
            if (textScrollWidth > textWidth) {
                this.setState({ button: 'spread' });
            }
        }
    }

    handleSpread() {
        this.setState({ button: 'put' }, () => {
            this.props.setLine && this.props.setLine();
        });
    }

    handlePut() {
        this.setState({ button: 'spread' }, () => {
            this.props.setLine && this.props.setLine();
        });
    }

    renderButton() {
        const { spread, fold } = this.props.translation;
        switch (this.state.button) {
            case 'spread':
                return (
                    <span
                        className="approval-opt-spread"
                        onTouchTap={this.handleSpread}>
                        {spread}
                    </span>
                );
            case 'put':
                return (
                    <div
                        className="approval-opt-put"
                        onTouchTap={this.handlePut}>
                        {fold}
                    </div>
                );
            default:
                return '';
        }
    }

    renderText() {
        const { text } = this.props;
        return (
            <div
                ref="approvalText"
                className={classNames(
                    'approval-opt-text',
                    { spread: this.state.button == 'spread' },
                    { put: this.state.button == 'put' }
                )}>
                {decode(text)}
            </div>
        );
    }

    render() {
        return (
            <div className="approval-opt-container border-1px">
                {this.renderText()}
                {this.renderButton()}
            </div>
        );
    }
}
export default ApprovalOpt;



// WEBPACK FOOTER //
// ./src/components/Approval/new/ApprovalOpt.js